// extracted by mini-css-extract-plugin
module.exports = {"InputLabel":"style_InputLabel__3_Qr5","mark":"style_mark__32DJO","height":"style_height__1Kjs5"};